import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common'
import { AssignDialogComponent } from './assign-dialog/assign-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { TruckActionDialogComponent, TruckAction } from './truck-action-dialog/truck-action-dialog.component';
import { UpdateTrucksDialogComponent, UpdateTrucksResult } from './update-trucks-dialog/update-trucks-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { APIService } from '../backend-service/backend-service';
import { GlobalVariablesService } from '../../global.service';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-transport-mangagement',
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './transport-mangagement.component.html',
  styleUrl: './transport-mangagement.component.scss'
})
export class TransportMangagementComponent implements OnDestroy {
  datas: any[] = [];
  filteredDatas: any[] = [];
  sortedTruckTypeFilters: string[] = [];
  selectedTruckTypeFilter: string | null = null;
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  selectedItems: string[] = [];
  truckAvailableList: any[] = [];
  isLoading: boolean = false;
  activePopoverData: any = null;
  popoverX: number = 0;
  popoverY: number = 0;
  private loadingSubscription: Subscription;

  constructor(private dialog: MatDialog, private apiService: APIService,
    private globalVariable: GlobalVariablesService,
    private notification: NotificationService, public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  openAssignDialog(order: any): void {
    if (order.remainingTrucksNeeded === 0) {
      this.openTruckActionDialog(order);
      return;
    }

    const truckOptions = this.buildTruckOptions();
    const dialogRef = this.dialog.open(AssignDialogComponent, {
      width: '500px',
      data: { order, trucks: truckOptions }
    });

    dialogRef.afterClosed().subscribe((result: number[]) => {
      if (result && result.length > 0) {
        this.assignTruck(order.id, result);
      }
    });
  }

  private buildTruckOptions(): { id: any; name: any; truckTypeName: string }[] {
    return this.truckAvailableList.map((truck) => {
      const plateNumber = truck['plateNumber'] ?? '';
      const truckTypeName = truck['truckType']?.name ?? '';
      return {
        id: truck['id'],
        name: plateNumber + (truckTypeName ? ` (${truckTypeName})` : ''),
        truckTypeName
      };
    });
  }

  openTruckActionDialog(order: any): void {
    const dialogRef = this.dialog.open(TruckActionDialogComponent, {
      width: '460px',
      data: { order }
    });

    dialogRef.afterClosed().subscribe((action: TruckAction | undefined) => {
      if (action === 'resubmit') {
        const existingIds = order.assignedTrucks.map((t: any) => t.id);
        this.assignTruck(order.id, existingIds);
      } else if (action === 'update') {
        this.openUpdateTrucksDialog(order);
      }
    });
  }

  openUpdateTrucksDialog(order: any): void {
    const truckOptions = this.buildTruckOptions();
    const dialogRef = this.dialog.open(UpdateTrucksDialogComponent, {
      width: '560px',
      data: { order, availableTrucks: truckOptions }
    });

    dialogRef.afterClosed().subscribe((result: UpdateTrucksResult | undefined) => {
      if (!result) return;

      const unassignDone = () => {
        if (result.assignIds.length > 0) {
          this.assignTruck(order.id, result.assignIds);
        } else {
          setTimeout(() => { this.getTrucksList(); this.getOrderList(); }, 1000);
        }
      };

      if (result.unassignIds.length > 0) {
        this.unassignTrucksBatch(order.id, result.unassignIds, unassignDone);
      } else {
        unassignDone();
      }
    });
  }

  unassignTrucksBatch(orderId: number, truckIds: number[], onDone: () => void): void {
    let loginData = JSON.parse(localStorage.getItem('loginData')!);
    const body = { truckIds };
    this.apiService.put(`/api/orders/${orderId}/unassign-truck`, body, loginData.token).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 201) {
          this.notification.success('Truck(s) unassigned successfully');
          onDone();
        } else {
          const msg = response.body?.message || 'Failed to unassign truck(s). Please try again.';
          this.notification.error(msg);
        }
      },
      error: (error) => {
        console.error('Unassign error:', error);
        const msg = error?.error?.message || error?.message || 'Failed to unassign truck(s). Please try again.';
        this.notification.error(msg);
      }
    });
  }


  ngOnInit() {
    this.getOrderList();
    this.getTrucksList();
  }
  getOrderList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/transport-management?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
    // this.apiService.get(`/api/orders?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/orders/list' + ',\n' + 'Order_List_Response:', response.body);
        if (response.status === 200 || response.status === 201) {
//           let mockResponse = {
//   "success": true,
//   "orders": [
//     {
//       "id": 76,
//       "reference": "5264881336",
//       "customerId": 36,
//       "consigneeId": 30,
//       "pickupLocationId": 55,
//       "deliveryLocationId": 37,
//       "pickupLocation": {
//         "address": "Dey Huy",
//         "locationPin": "11.436809580627438,104.95752739440789",
//         "notes": "Selected pickup location"
//       },
//       "deliveryLocation": {
//         "address": "123 Main Street, Phnom Penh, Cambodia",
//         "locationPin": "11.5564,104.9282",
//         "notes": "Headquarters"
//       },
//       "pickupDate": "2026-04-09T00:00:00.000Z",
//       "deliveryDate": "2026-04-11T00:00:00.000Z",
//       "totalWeight": "2",
//       "weightUnit": "kg",
//       "numberOfTrucksOrder": 2,
//       "truckTypesLoaded": [
//         {
//           "truckType": 23,
//           "numberOfTruck": "1"
//         },
//         {
//           "truckType": 24,
//           "numberOfTruck": "1"
//         }
//       ],
//       "loadingMethod": null,
//       "unloadingMethod": null,
//       "tax": "NON_TAX",
//       "bookingType": "SINGLE",
//       "totalVolumeM3": null,
//       "chargeableWeightKg": null,
//       "pricingModel": "PER_TRIP",
//       "assignedTrucks": [
//         {
//           "id": 41,
//           "plateNumber": "4AB-8221",
//           "truckType": "1.5ton",
//           "truckModel": 2020,
//           "driverName": "Puthireach",
//           "driverPhone": "012847473"
//         },
//         {
//           "id": 42,
//           "plateNumber": "3A-3699",
//           "truckType": "3ton",
//           "truckModel": 2020,
//           "driverName": "Puthireach",
//           "driverPhone": "012847473"
//         }
//       ],
//       "orderBookingStatus": 132,
//       "pickedUpAt": null,
//       "inTransitAt": null,
//       "deliveredAt": null,
//       "createdAt": "2026-04-09T07:41:13.389Z",
//       "updatedAt": "2026-04-09T07:41:13.389Z",
//       "customer": {
//         "id": 36,
//         "name": "Pisey Collection"
//       },
//       "consignee": {
//         "id": 30,
//         "name": "ABC Logistics Test Update"
//       },
//       "cargoItems": [
//         {
//           "id": 74,
//           "bookingId": 76,
//           "commodityTypeId": null,
//           "description": "2",
//           "quantity": "2.00",
//           "packagingType": 170,
//           "lengthCm": "2.00",
//           "widthCm": "2.00",
//           "heightCm": "2.00",
//           "volumeM3": "2.0000",
//           "grossWeightKg": "2.00",
//           "stackable": true,
//           "dgFlag": true,
//           "temperatureControl": 1,
//           "handlingType": 1,
//           "isActive": true,
//           "createdAt": "2026-04-09T07:41:13.398Z",
//           "updatedAt": "2026-04-09T07:41:13.398Z"
//         }
//       ],
//       "stops": [],
//       "isDraft": false,
//       "remainingTrucksNeeded": 1,
//       "remainingByType": [
//         {
//           "truckType": "3.5ton",
//           "remaining": 1
//         },
//         {
//           "truckType": "5ton",
//           "remaining": 1
//         }
//       ]
//     }
//   ],
//   "pagination": {
//     "currentPage": 1,
//     "totalPages": 2,
//     "totalItems": 19,
//     "itemsPerPage": 10
//   }
// };
          // mockResponse.orders.forEach((data: { [x: string]: any; }) => {
          response.body.orders.forEach((data: { [x: string]: any; }) => {
            try {
              this.datas.push({
                id: data["id"],
                ref: data["reference"],
                customer: data["customer"]["name"],
                truckType: this.mapTruckType(data["truckTypesLoaded"]),
                assignedTrucks: data["assignedTrucks"] ?? [],
                remainingTrucksNeeded: data["remainingTrucksNeeded"] ?? 0,
                remainingByType: data["remainingByType"] ?? [],
                slaDelivery: formatDate(data["deliveryDate"], 'yyyy-MM-dd', 'en-US')
              })
            } catch (error) {

            }
          });
          console.log("Data: ", this.datas);
          this.buildTruckTypeFilters();
          this.setTruckTypeFilter(this.selectedTruckTypeFilter);
          const pagination = response.body.pagination;
          if (pagination && pagination.totalPages > 0) {
            this.totalPages = pagination.totalPages;
            this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          }
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  getTrucksList() {
    this.truckAvailableList = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/trucks/available/list`, loginData.token, { skipLoading: true }).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/trucks/available/list' + ',\n' + 'Trucks_List_Response:', response.body);
        if (response.status === 200 || response.status === 201) {
          response.body.trucks.forEach((data: { [x: string]: any; }) => {
            this.truckAvailableList.push({
              id: data["id"],
              plateNumber: data["plateNumber"],
              truckType: data["truckType"],
              truckTypeId: data["truckTypeId"],
              truckLoadingCapacity: data["truckLoadingCapacity"],
              boxSize: data["boxSize"],
              truckStatus: data["truckStatus"],
              driver: data["driver"]
            })
          });
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  mapTruckType(truckTypes: any): string {
    let truckTypeArray: string[] = [];
    truckTypes.forEach((element: any) => {
      let truckTypeObj = this.globalVariable.SETTING_TRUCK_TYPES.find((obj: any) => obj.id === element["truckType"]);
      let truckExt = element["numberOfTruck"] > 1 ? " trucks" : " truck";
      truckTypeArray.push("[" + (truckTypeObj?.name ?? element["truckType"]) + " : " + element["numberOfTruck"] + truckExt + "]");
    });
    return truckTypeArray.join(", ");
  }

  assignTruck(orderId: number, truckIds: number[]) {
    console.log("Order ID: ", orderId);
    console.log("Truck IDs: ", truckIds);
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    const trucksIdsList: any = {
      truckIds: truckIds
    };
    console.log("Request Body: ", trucksIdsList);
    this.apiService.post(`/api/orders/${orderId}/assign-trucks`, trucksIdsList, loginData.token).subscribe({
        next: response => {
          console.log('HTTP Status:', response.status); // 👈 Get status here
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Assign Truck successfully');
            setTimeout(() => {
              this.getTrucksList();
              this.getOrderList();
            }, 1000);
          }
          else {
            this.notification.error('Register Driver failed. Please try again.');
          }
          // this.location.back();
        },
        error: error => {
          console.error('Error:', error);
          const msg = error?.error?.message || error?.message || 'Assign truck failed. Please try again.';
          this.notification.error(msg);
        }
      });
  }

  @HostListener('document:click')
  closePopover(): void {
    this.activePopoverData = null;
  }

  togglePopover(data: any, event: MouseEvent): void {
    if (this.activePopoverData === data) {
      this.activePopoverData = null;
      return;
    }
    const trigger = event.currentTarget as HTMLElement;
    const rect = trigger.getBoundingClientRect();
    const popoverWidth = 260;
    const centeredLeft = rect.left + rect.width / 2 - popoverWidth / 2;
    const maxLeft = window.innerWidth - popoverWidth - 8;
    this.popoverX = Math.min(Math.max(8, centeredLeft), maxLeft);
    this.popoverY = rect.bottom + 8;
    this.activePopoverData = data;
  }

  confirmUnassignTruck(order: any, truck: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: truck.plateNumber }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.unassignTruck(order.id, truck.id);
      }
    });
  }

  unassignTruck(orderId: number, truckId: number): void {
    let loginData = JSON.parse(localStorage.getItem('loginData')!);
    const trucksIdsList: any = {
      truckIds: [truckId]
    };
    console.log("Unassign Request Body: ", trucksIdsList);
    this.apiService.put(`/api/orders/${orderId}/unassign-truck`, trucksIdsList, loginData.token).subscribe({
      next: (response) => {
        console.log('Unassign response:', response.body);
        if (response.status === 200 || response.status === 201) {
          this.notification.success('Truck unassigned successfully');
          setTimeout(() => {
            this.getTrucksList();
            this.getOrderList();
          }, 1000);
        } else {
          const msg = response.body?.message || 'Failed to unassign truck. Please try again.';
          this.notification.error(msg);
        }
      },
      error: (error) => {
        console.error('Unassign error:', error);
        const msg = error?.error?.message || error?.message || 'Failed to unassign truck. Please try again.';
        this.notification.error(msg);
      }
    });
  }

  private parseTruckWeight(name: string): number {
    const match = name.match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : Infinity;
  }

  private buildTruckTypeFilters(): void {
    const typeSet = new Set<string>();
    this.datas.forEach(order => {
      this.parseTruckTypes(order.truckType).forEach(t => typeSet.add(t.type));
    });
    this.sortedTruckTypeFilters = Array.from(typeSet).sort(
      (a, b) => this.parseTruckWeight(a) - this.parseTruckWeight(b)
    );
  }

  setTruckTypeFilter(type: string | null): void {
    this.selectedTruckTypeFilter = type;
    if (type === null) {
      this.filteredDatas = [...this.datas];
    } else {
      this.filteredDatas = this.datas.filter(order =>
        this.parseTruckTypes(order.truckType).some(t => t.type === type)
      );
    }
  }

  parseTruckTypes(truckTypeString: string): { type: string, count: number }[] {
    // Parse string like "[2.5ton : 2 trucks], [3.5ton : 1 truck]"
    const result: { type: string, count: number }[] = [];
    const regex = /\[(.*?)\s*:\s*(\d+)\s*truck[s]?\]/g;
    let match;

    while ((match = regex.exec(truckTypeString)) !== null) {
      result.push({
        type: match[1].trim(),
        count: parseInt(match[2])
      });
    }

    return result;
  }

}
